(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SelectBatchItemModalController', SelectBatchItemModalController);

    SelectBatchItemModalController.$inject = ['$rootScope', '$scope', '$state', 'CompanyCustomer', 'CompanyCustomerSearch', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'CustomerCustom', 'CompanyCustomerCustom', '$mdDialog', '$translatePartialLoader', '$timeout', 'ServiceItemCustom', 'ServiceAddOnCustom', 'ServantCustom'];

    function SelectBatchItemModalController($rootScope, $scope, $state, CompanyCustomer, CompanyCustomerSearch, PersonInfo, Customer, ParseLinks, AlertService, CustomerCustom, CompanyCustomerCustom, $mdDialog, $translatePartialLoader, $timeout, ServiceItemCustom, ServiceAddOnCustom, ServantCustom) {

        var vm = this;
        vm.items = [];
        vm.loadAll = loadAll;
        vm.itemSelectionType = "SERVICE";
        vm.onServiceChanged = onServiceChanged;
        vm.servant_changed = servant_changed;
        vm.canEditCapacity = true;
        vm.addServiceItem = addServiceItem;
        vm.serviceItemList = null;
        vm.onServiceItemClick = onServiceItemClick;
        vm.onServiceAddOnClick = onServiceAddOnClick;
        vm.deleteItem = deleteItem;
        vm.tabChanged = tabChanged;
        vm.noItemMsg = 'هیچ آیتمی انتخاب نشده است';
        vm.noServiceAddOnMsg = 'هیچ خدمت ویژه ای تعریف نشده است';
        vm.goToServiceAddOn = goToServiceAddOn;
        vm.allServants = [];

        vm.activityTypeInfo = {};
        vm.activityTypeInfo.servantTitle = "پرسنل";


        loadAll();


        vm.closeModal = closeModal;
        vm.okModal = okModal;

        vm.getModalTitle = getModalTitle;


        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $translatePartialLoader.addPart('commissionItemType');
            $rootScope.$broadcast('hideNavBar');
            window.scroll(0, 0);

            // getAllActiveServants();
            getAllServiceItems();
            getAllServiceAddOns();

        }

        function okModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.close(vm.items);
            }
        }

        function closeModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
                return;
            }
        }

        function getModalTitle() {
            return 'tikonApp.commission.addBatchItem.title';
        }


        function getAllServiceItems() {
            ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (list) {
                vm.serviceItemList = list;
            })

        }


        function onServiceChanged() {

            // if(vm.selectedServiceItem)
            //     ;

        }

        function servant_changed() {

        }


        function addServiceItem() {
            if (!vm.selectedServiceItem)
                return;

            var item = {};
            item.title = vm.selectedServiceItem.itemTitle;
            item.id = vm.selectedServiceItem.id;
            item.type = 'SERVICE';
            item.randomNo = Math.floor(Math.random() * 10000);

            vm.items.push(item);
            resetSelectedItems();
        }


        function resetSelectedItems() {
            vm.selectedServiceItem = null;
        }

        function onServiceItemClick(serviceItem) {

            vm.selectedServiceItem = serviceItem;
            addServiceItem();
        }

        function onServiceAddOnClick(addOn) {
            addServiceAddOn(addOn);
        }

        function addServiceAddOn(addOn) {

            if (!addOn)
                return;
            var item = {};
            item.title = addOn.title;
            item.id = addOn.id;
            item.type = 'SERVICE_ADD_ON';
            item.randomNo = Math.floor(Math.random() * 10000);

            vm.items.push(item);
        }

        function deleteItem(selectedItem) {
            vm.items = vm.items.filter(function (item) {
                if (selectedItem.randomNo != item.randomNo) {
                    return selectedItem;
                }

            })

        }

        function getAllServiceAddOns() {
            ServiceAddOnCustom.getActiveServiceAddOns().query(function (list) {
                vm.serviceAddOnList = list;
            })

        }

        function tabChanged(tabName) {
            if (tabName == 'serviceAddOnTab')
                vm.itemSelectionType = 'SERVICE_ADD_ON';
            else
                vm.itemSelectionType = 'SERVICE';

        }

        function goToServiceAddOn() {
            $state.go('supplierPanel-v2.serviceAddOnList');
            closeModal();
        }

        $scope.$watch('vm.selectedServiceItem', function () {

            if (!vm.selectedServiceItem) {
                var elem = document.getElementById("serviceListId");
                if (elem)
                    elem.focus();

                return;
            }

        })

    }
})();
